module.exports = __webpack_public_path__ + "static/cycle-a47421639f13437c3f9e495691606ae5.svg";